import { HtmlOverlayAnimationComponent } from "./html-overlay-animation-component"
import './../../css/quiz.css'


export class QuizAnswersComponent extends HtmlOverlayAnimationComponent {
    constructor(itemMetadata) {
        super(itemMetadata)
        this.quizId = itemMetadata.quizId
        this.out = itemMetadata.out
        this.pollPreviouslySubmitted = false
        this.fontSize = itemMetadata.fontSize;
        this.enlargeImage = itemMetadata.enlargeImage


    }
    TweenIn(data) {
        if (data != null && data.enlarge == true) {
            if (document.querySelector("video").currentTime >= (this.out - 1))
                return;
            if (!this.div.querySelector(".quizAnswerContent").classList.contains("enlarged")) {
                this.div.querySelector(".quizAnswerContent").classList += " enlarged";
            }
            if (this.div.querySelector(".quizAnswerContent").classList.contains("shrinkedImage")) {
                this.div.querySelector(".quizAnswerContent").classList.remove("shrinkedImage");
            }
            return;
        }
        if (!document.querySelector("video").classList.contains("shrinked")) {
            document.querySelector("video").classList += " shrinked";
        }
        super.TweenIn()
        if (this.enlargeImage) {
            if (this.div.querySelector(".quizAnswerContent").classList.contains("enlarged")) {
                this.div.querySelector(".quizAnswerContent").classList.remove("enlarged");
            }
            if (!this.div.querySelector(".quizAnswerContent").classList.contains("shrinkedImage")) {
                this.div.querySelector(".quizAnswerContent").classList += " shrinkedImage";
            }
        }
        if (this.fontSize != null) {
            this.div.querySelector(".questionOptionsOrderedList").style.fontSize = this.fontSize + "px";
            this.div.querySelector(".questionText").style.fontSize = (this.fontSize + 2) + "px";
        }
        var questionNumberDiv = this.div.querySelector(".questionNumber")
        var questionTextDiv = this.div.querySelector(".questionText")
        var questionOptionsOrderedList = this.div.querySelector(".questionOptionsOrderedList")
        var quizOptionsContentDiv = this.div.querySelector(".quizAnswerContent")
        quizOptionsContentDiv.style.display = "block";
        var quizAnswerImagesContDiv = this.div.querySelector(".quizAnswerImagesCont")
        var quizQuestionLoadContainer = this.div.querySelector(".quizQuestionLoadContainer")
        quizQuestionLoadContainer.style.display = "flex";

        var that = this;
        fetch("https://interactive-eular.com/api/get-full-quiz-data-from-id?Id=" + this.quizId).then(response => response.json()).then((data) => {
            var spacePos = data.question.indexOf(' ');
            questionNumberDiv.innerHTML = "Question " + data.question.slice(0, spacePos);
            questionTextDiv.innerHTML = data.question.slice(spacePos, data.question.length);
            questionOptionsOrderedList.innerHTML = "";
            for (var i = 0; i < data.Options.length; i++) {
                if (data.Options[i].isCorrect)
                    questionOptionsOrderedList.innerHTML += "<li style='color:red'>" + data.Options[i].name + "</li>"
                else
                    questionOptionsOrderedList.innerHTML += "<li>" + data.Options[i].name + "</li>"
            }
            quizAnswerImagesContDiv.innerHTML = "";
            if (data._id == "5f7c355e20c00200122ca5e7") {
                quizAnswerImagesContDiv.innerHTML += "<img src='https://interactive-eular.com/images/" + data.answerImages[0].name + "' class='single'></img>"
                var img = document.createElement("img");
                this.div.querySelector(".quizAnswerContent").classList += " smaller"
                img.src = "https://interactive-eular.com/images/" + data.answerImages[1].name
                that.div.querySelector(".horImageCont").appendChild(img);
            } else if (data.answerImages.length == 1 && data.answerImages[0].posy == "bottom") {
                that.div.querySelector(".quizTextContainer").style.height = "unset";
                that.div.querySelector(".questionOptionsList").style.fontSize = "16px";
                that.div.querySelector(".questionOptionsList").style.paddingTop = "20px";
                that.div.querySelector(".quizAnswerImagesCont").style.flex = 1;
                that.div.querySelector(".quizAnswerImagesCont").style.overflow = "hidden";
                that.div.querySelector(".quizAnswerContent").style.flexDirection = "column";
                quizAnswerImagesContDiv.innerHTML += "<img style='max-width:unset;margin: 0 auto;width:auto;max-height:unset;height:100%;' src='https://interactive-eular.com/images/" + data.answerImages[0].name + "'></img>"

            } else if (data.answerImages.length == 1 && data.answerImages[0].posy == "center") {

                that.div.querySelector(".quizAnswerImagesCont").style.justifyContent = "center";
                for (var i = 0; i < data.answerImages.length; i++) {
                    quizAnswerImagesContDiv.innerHTML += "<img src='https://interactive-eular.com/images/" + data.answerImages[i].name + "' class='single'></img>"
                }

            } else if (data.answerImages.length == 2 && data.answerImages[0].posy == "bottom" && data.answerImages[1].posy == "bottom") {
                that.div.querySelector(".quizTextContainer").style.height = "unset";
                that.div.querySelector(".questionOptionsList").style.fontSize = "16px";
                that.div.querySelector(".questionOptionsList").style.paddingTop = "20px";
                that.div.querySelector(".quizAnswerImagesCont").style.flex = 1;
                that.div.querySelector(".quizAnswerImagesCont").style.overflow = "hidden";
                that.div.querySelector(".quizAnswerContent").style.flexDirection = "column";
                that.div.querySelector(".quizAnswerImagesCont").style.flexDirection = "row";
                quizAnswerImagesContDiv.innerHTML += "<img style='max-height:unset;height:100%;' src='https://interactive-eular.com/images/" + data.answerImages[0].name + "'></img><img style='max-height:unset;height:100%;' src='https://interactive-eular.com/images/" + data.answerImages[1].name + "'></img>"
            } else if (data.answerImages.length == 1) {
                quizAnswerImagesContDiv.innerHTML += "<img src='https://interactive-eular.com/images/" + data.answerImages[0].name + "' class='single'></img>"
            } else {
                for (var i = 0; i < data.answerImages.length; i++) {
                    quizAnswerImagesContDiv.innerHTML += "<img src='https://interactive-eular.com/images/" + data.answerImages[i].name + "'></img>"
                }
            }
            quizQuestionLoadContainer.style.display = "none";
            quizOptionsContentDiv.style.display = "flex";
        });
    }

    TweenOut(SetWasDismissedByApplication) {
        if (document.querySelector("video").classList.contains("shrinked")) {
            document.querySelector("video").classList.remove("shrinked");
        }
        super.TweenOut(SetWasDismissedByApplication)
    }
    setCookie(c_name, value, exdays) {
        var exdate = new Date();
        exdate.setDate(exdate.getDate() + exdays);
        var c_value = escape(JSON.stringify(value)) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
        document.cookie = c_name + "=" + c_value;
    }

    getCookie(c_name) {
        var i, x, y, ARRcookies = document.cookie.split(";");
        for (i = 0; i < ARRcookies.length; i++) {
            x = ARRcookies[i].substr(0, ARRcookies[i].indexOf("="));
            y = ARRcookies[i].substr(ARRcookies[i].indexOf("=") + 1);
            x = x.replace(/^\s+|\s+$/g, "");
            if (x == c_name) {
                return JSON.parse(unescape(y));
            }
        }
    }


}